import React from "react";

function Income() {
  return (
    <div>
      <h2>Ingresos</h2>
      <p>Gestión de ingresos en proceso.</p>
    </div>
  );
}

export default Income;
